import { backendUrl } from "./backendUrl";

const CAREERS_API_URL = backendUrl("/Api/careers.php");

export async function submitCareerApplication(formData) {
  const response = await fetch(CAREERS_API_URL, {
    method: "POST",
    body: formData,
  });

  let data = null;

  try {
    data = await response.json();
  } catch (error) {
    throw new Error("The careers server returned an invalid response.");
  }

  if (!response.ok || !data?.success) {
    throw new Error(data?.message || "The application could not be submitted.");
  }

  return data;
}
